<list-chart-card *ngIf="{ compactDesign: false } as tmpState" (onCompactDesignChange)="tmpState.compactDesign = $event" [title]="title" [queryOptions]="queryOptions" [dateRanges]="dateRanges" [statusesList]="statusesList"
  [chartTotalLabel]="chartTotalLabel" [statusListItemOrdersLabel]="statusListItemOrdersLabel"
  [emptyListText]="emptyListText" [renderTotals]="extended" [buttonLabel]="buttonLabel"
  [emptyButtonLabel]="emptyButtonLabel" [newDesignTranslation]="newDesignTranslation"
  [isNewDashboard2025Enabled]="isNewDashboard2025Enabled" #listChart>
  <a cxDisableContextMenu href="/invoices-payments/dashboard" slot="header-right" *ngIf="isNewDashboard2025Enabled"
    [ngStyle]="{'pointer-events' : !(listChart.changeEmitter$ | async) ? 'none' : 'inherit'}">
    <cwc-button design-version="v2" [disabled]="!(listChart.changeEmitter$ | async)" style="align-self: flex-start;"
      variant="link" size="medium">{{newDesignTranslation.viewMore}}</cwc-button>
  </a>
  <a cxDisableContextMenu href="/invoices-payments/financial-documents" slot="body-footer"
    *ngIf="isNewDashboard2025Enabled && listChart.changeEmitter$ | async">
    <cwc-button design-version="v2" style="justify-self: flex-end;"
      [variant]="tmpState.compactDesign ? 'regular-block' : 'regular'">{{newDesignTranslation.reviewInvoices}}</cwc-button>
  </a>
</list-chart-card>